<script setup lang="ts">
const props = defineProps({
  type: {
    type: String as () => "success" | "error" | "warn" | "info",
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  linkUrl: {
    type: String,
    required: false,
    default: "",
  },
  linkLabel: {
    type: String,
    required: false,
    default: "here",
  },
  altText: {
    type: String,
    required: true,
  },
});

const bgColor = computed(() => {
  switch (props.type) {
    case "success":
      return "bg-success-300";
    case "error":
      return "bg-error-300";
    case "warn":
      return "bg-warning-300";
    case "info":
      return "bg-rarity-exotic";
    default:
      return "";
  }
});
</script>
<template>
  <div class="w-full h-full flex items-center gap-4 p-4" :class="bgColor">
    <div class="flex items-center">
      <BaseIconNotification :type="type" />
    </div>
    <div class="flex flex-col text-sm text-black/60">
      <p class="font-bold">
        {{ title }}
      </p>
      <p class="">
        {{ message }}
        <a
          v-if="linkUrl"
          :href="linkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="ml-1 underline font-semibold text-black/70 hover:text-black"
        >
          {{ linkLabel }}
        </a>
      </p>
    </div>
  </div>
</template>
